/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OfferDto
 */
export interface OfferDto {
    /**
     *
     * @type {number}
     * @memberof OfferDto
     */
    offerId?: number;
    /**
     *
     * @type {string}
     * @memberof OfferDto
     */
    organisationId?: string;
    /**
     *
     * @type {string}
     * @memberof OfferDto
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof OfferDto
     */
    description?: string;
    /**
     *
     * @type {number}
     * @memberof OfferDto
     */
    discountPercent?: number;
    /**
     *
     * @type {string}
     * @memberof OfferDto
     */
    status?: OfferDtoStatusEnum;
    /**
     *
     * @type {Date}
     * @memberof OfferDto
     */
    startsAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof OfferDto
     */
    expiresAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof OfferDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof OfferDto
     */
    updatedAt?: Date;
    /**
     *
     * @type {number}
     * @memberof OfferDto
     */
    createdByUserAccountId?: number;
    /**
     *
     * @type {Array<string>}
     * @memberof OfferDto
     */
    deviceGroupTags?: Array<string>;
}

/**
 * @export
 */
export const OfferDtoStatusEnum = {
    Unknown: "Unknown",
    Active: "Active",
    Disabled: "Disabled",
    Archived: "Archived",
} as const;
export type OfferDtoStatusEnum =
    (typeof OfferDtoStatusEnum)[keyof typeof OfferDtoStatusEnum];

/**
 * Check if a given object implements the OfferDto interface.
 */
export function instanceOfOfferDto(value: object): value is OfferDto {
    return true;
}

export function OfferDtoFromJSON(json: any): OfferDto {
    return OfferDtoFromJSONTyped(json, false);
}

export function OfferDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OfferDto {
    if (json == null) {
        return json;
    }
    return {
        offerId: json["offerId"] == null ? undefined : json["offerId"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        name: json["name"] == null ? undefined : json["name"],
        description:
            json["description"] == null ? undefined : json["description"],
        discountPercent:
            json["discountPercent"] == null
                ? undefined
                : json["discountPercent"],
        status: json["status"] == null ? undefined : json["status"],
        startsAt:
            json["startsAt"] == null ? undefined : new Date(json["startsAt"]),
        expiresAt:
            json["expiresAt"] == null ? undefined : new Date(json["expiresAt"]),
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        createdByUserAccountId:
            json["createdByUserAccountId"] == null
                ? undefined
                : json["createdByUserAccountId"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
    };
}

export function OfferDtoToJSON(value?: OfferDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        offerId: value["offerId"],
        organisationId: value["organisationId"],
        name: value["name"],
        description: value["description"],
        discountPercent: value["discountPercent"],
        status: value["status"],
        startsAt:
            value["startsAt"] == null
                ? undefined
                : value["startsAt"].toISOString(),
        expiresAt:
            value["expiresAt"] == null
                ? undefined
                : value["expiresAt"].toISOString(),
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        createdByUserAccountId: value["createdByUserAccountId"],
        deviceGroupTags: value["deviceGroupTags"],
    };
}
